export enum NotificationTypes {
    Info = "info",
    Warning = "warning",
    Success = "success",
    Error = "error",
    Debug = "debug",
}
